import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import React from 'react';
import Section from "./Section";
import FieldWithDiff from "./FieldWithDiff";
import getPath from "./getPath";
var defaultComparatorSkippingNullAndUndefined = function defaultComparatorSkippingNullAndUndefined(a, b) {
  return (a == null || a === '') && (b == null || b === '') || a === b;
};
var SectionBuilder = function SectionBuilder(_ref) {
  var title = _ref.title,
    columns = _ref.columns,
    snapshot = _ref.snapshot,
    currentSnapshot = _ref.currentSnapshot,
    onCommit = _ref.onCommit,
    committedKeys = _ref.committedKeys,
    sectionKeys = _ref.sectionKeys,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Section, {
    title: title,
    columns: columns
  }, Object.keys(sectionKeys).map(function (sectionKey) {
    var _sectionKeys$sectionK = sectionKeys[sectionKey],
      title = _sectionKeys$sectionK.title,
      _sectionKeys$sectionK2 = _sectionKeys$sectionK.Wrapper,
      Wrapper = _sectionKeys$sectionK2 === void 0 ? React.Fragment : _sectionKeys$sectionK2,
      formatter = _sectionKeys$sectionK.formatter,
      _sectionKeys$sectionK3 = _sectionKeys$sectionK.comparator,
      comparator = _sectionKeys$sectionK3 === void 0 ? defaultComparatorSkippingNullAndUndefined : _sectionKeys$sectionK3;
    var snapshotValue = getPath(sectionKey, snapshot);
    var formattedSnapshotValue = formatter ? formatter(snapshotValue) : snapshotValue;
    var currentValue = getPath(sectionKey, currentSnapshot);
    var formattedCurrentValue = formatter ? formatter(currentValue) : currentValue;
    var hasDifference = !comparator(formattedCurrentValue, formattedSnapshotValue);
    return /*#__PURE__*/React.createElement(Wrapper, {
      key: sectionKey
    }, /*#__PURE__*/React.createElement(FieldWithDiff, {
      committed: committedKeys && committedKeys.indexOf(sectionKey) >= 0,
      diffKey: sectionKey,
      diffValue: hasDifference ? formattedCurrentValue : undefined,
      onCommit: onCommit,
      title: title
    }, formattedSnapshotValue));
  }), children);
};
export default /*#__PURE__*/React.memo(SectionBuilder);